import { render, staticRenderFns } from "./groupChatTypeLayout.vue?vue&type=template&id=876d69bc&scoped=true&"
import script from "./groupChatTypeLayout.vue?vue&type=script&lang=js&"
export * from "./groupChatTypeLayout.vue?vue&type=script&lang=js&"
import style0 from "./groupChatTypeLayout.vue?vue&type=style&index=0&id=876d69bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876d69bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('876d69bc')) {
      api.createRecord('876d69bc', component.options)
    } else {
      api.reload('876d69bc', component.options)
    }
    module.hot.accept("./groupChatTypeLayout.vue?vue&type=template&id=876d69bc&scoped=true&", function () {
      api.rerender('876d69bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/components/newGroupChat/groupChatTypeLayout.vue"
export default component.exports